import { ObjectHelper } from '../../..'

export class ModelInclude {

  public static BRANCH_DELIMITER: string = '.'

  private _objectHelper: ObjectHelper
  private _memoizedArray: string[]

  private static _toBranches(object: { [key: string]: any }): string[] {
    return Object.keys(object).reduce((result, key) => {
      const entries = ModelInclude._toBranches(object[key])
        .map((entry) => `${key}${ModelInclude.BRANCH_DELIMITER}${entry}`)
      if (entries.length === 0) { entries.push(key) }
      return result.concat(entries)
    }, [])
  }

  constructor(private _object: { [key: string]: any } = {}) {
    this._objectHelper = new ObjectHelper()
  }

  public includes(other: ModelInclude) {
    return this._objectHelper.isSubset(this.toObject(), other.toObject())
  }

  public equals(other: ModelInclude) {
    return this._objectHelper.areMutualSubsets(this.toObject(), other.toObject())
  }

  public isEmpty() {
    return Object.keys(this._object).length === 0
  }

  public hasIncludedProperty(propertyName: string) {
    return !!this._object[propertyName]
  }

  public scopeTo(propertyName: string): ModelInclude {
    return new ModelInclude(this._object[propertyName] || {})
  }

  public toObject(): { [key: string]: any } {
    return this._object
  }

  public toArray(): string[] {
    if (!this._memoizedArray) {
      this._memoizedArray = ModelInclude._toBranches(this._object)
    }
    return this._memoizedArray
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/model-include/model-include.ts